<template>
  <el-dialog :visible.sync="visible" :title="'课程设置'" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
    <div class="mod-teachercourse__teachercourse">

      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column  header-align="center" align="center" >
          <template slot-scope="scope">
            <el-button v-if="isInArray(scope.row)"  size="mini" @click="setInspector(scope.row)">选中</el-button>
            <el-button v-else=""  type="danger" size="mini" @click="removeInspector(scope.row)">移除所教课程</el-button>
          </template>
        </el-table-column>

        <el-table-column prop="courseName" label="课程名" header-align="center" align="center"></el-table-column>

      </el-table>
      <el-pagination
              :current-page="page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="limit"
              :total="total"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="pageSizeChangeHandle"
              @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import Template from '../devtools/template'
import mixinViewModule from '@/mixins/view-module'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/course/course/page',
        getDataListIsPage: true,
        deleteURL: '/course/course',
        deleteIsBatch: true
      },
      visible: false,
      dataForm: {
        id: '',
        teacherName: '',
        teacherId: '',
        courseId: '',
        courseName: '',
        classId: '',
        className: ''

      },
      submitForm: {
        id: '',
        teacherName: '',
        teacherId: '',
        courseId: '',
        courseName: '',
        classId: '',
        className: ''

      },
      checkedCourses: [],
      courseList: [],
      courList: []
    }
  },
  computed: {
    dataRule () {
      return {
      }
    }
  },
  methods: {
    init () {
      this.visible = true

      this.$nextTick(() => {
        this.getCheckCourse()
      })
    },
    isInArray (row) {
      // console.log(row)
      for (var i = 0; i < this.checkedCourses.length; i++) {
        // console.log(this.checkedCourses[i].courseId)
        if (row.id === this.checkedCourses[i].courseId) {
          return false
        }
      }
      return true
    },
    removeInspector (row) {
    //  console.log(row)
      this.$http.get('/teachercourse/teachercourse/removeCourseTeacher', {
        params: {
          courseId: row.id,
          classId: this.submitForm.classId,
          teacherId: this.submitForm.teacherId
        }
      }).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.init()
        this.$emit('refreshDataList')
        this.$notify({
          type: 'info',
          duration: '750',
          message: '授课课程移除成功'
        })
      })
    },
    /**
     * 设置教师课程
     */
    setInspector (row) {
      // 组装参数
      this.submitForm.courseName = row.courseName
      this.submitForm.courseId = row.id
      this.$http.get('teachercourse/teachercourse/getIsSetCourseList', {
        params: {
          courseId: this.submitForm.courseId,
          classId: this.submitForm.classId
        }
      }).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.courList = res.data
        console.log(this.courList, '+++++++++++++++++++++++++')

        if (this.courList.length > 0) {
          this.$confirm(this.$t('prompt.info', { handle: this.$t('替换') }), `该班级课程已有老师授课(${this.courList[0].teacherName})`, {
            confirmButtonText: this.$t('confirm'),
            cancelButtonText: this.$t('cancel'),
            type: 'warning'
          }).then(() => {
            this.setInspectors(row)
          })
        } else {
          this.setInspectors(row)
        }
      })
    },
    setInspectors (row) {
      this.submitForm.courseName = row.courseName
      this.submitForm.courseId = row.id
      this.$http.post('/teachercourse/teachercourse', this.submitForm).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.init()
        this.$emit('refreshDataList')
        this.$notify({
          type: 'success',
          duration: '750',
          message: '授课课程设置成功'
        })
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get('/teachercourse/teachercourse/' + this.submitForm.id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.submitForm = {
          ...this.submitForm,
          ...res.data
        }
      }).catch(() => {})
    },
    getCheckCourse () {
      this.$http.get('/teachercourse/teachercourse/page', {
        params: {
          classId: this.submitForm.classId,
          teacherId: this.submitForm.teacherId
        }
      }).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }

        this.checkedCourses = res.data.list
        // console.log(this.checkedCourses)
        // console.log(this.dataForm.checkedCourse+"dsds")
      }).catch(() => {})
    },
    // 获取信息
    getCourse () {
      this.$http.get('/course/course/page').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }

        this.courseList = res.data.list
        for (let i = 0; i < this.checkedCourses.length; i++) {
          this.courses.push(this.courseList[i].id)
        }
        console.log(this.courses)
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs.submitForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.submitForm.id ? 'post' : 'put']('/teachercourse/teachercourse/', this.submitForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { leading: true, trailing: false })
  },
  components: {
    Template
  }
}
</script>
